import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { setNewForm } from 'apps/auth/actions/formAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { SEND_FORM_NAME } from 'apps/auth/constants/formName';

import MainACHModal from './Ach/MainACHModal';
import FlinksModal from './Flinks/FlinksModal';
import LeanModal from './Lean/LeanModal';
import MainOfakimHandleModal from './ofakim/MainOfakimHandleModal';
import { MainOfakimModal } from './ofakim/MainOfakimModal';
import PlaidBankModal from './Plaid/PlaidBankModal';

const SdkModals = (props) => {
    const { modals, modalRef, submitRef, popupRef, paymentMethod, changePaymentMethodPlaid, typeOfTransfer, onClosePlaidModal } = props;
    if (modals.isOfakim) {
        return (
            <MainOfakimModal
                onClickNotNow={(e) => {
                    e.preventDefault();
                    modalRef?.current?.close();
                }}
                toggleSpinner={props.toggleSpinner}
                setNewForm={props.setNewForm}
                addExtras={props.addExtras}
                showIntro={true}
                updatePageMessages={props.updatePageMessages}
                onClickOfakimStatus={() => modalRef?.current?.close()}
                insideModalComponent
            />
        );
    }
    if (modals.isOfakimHandle) {
        return (
            <MainOfakimHandleModal
                onClickNotNow={(e) => {
                    e.preventDefault();
                    modalRef?.current?.close();
                }}
                toggleSpinner={props.toggleSpinner}
                setNewForm={props.setNewForm}
                addExtras={props.addExtras}
                showIntro={true}
                updatePageMessages={props.updatePageMessages}
                onClickOfakimStatus={() => modalRef?.current?.close()}
                insideModalComponent
            />
        );
    }
    if (modals.isAch) {
        return <MainACHModal modalRef={modalRef} popupRef={popupRef} />;
    }
    if (modals.isLean) {
        return <LeanModal modalRef={modalRef} />;
    }
    if (modals.isPlaid) {
        return (
            <PlaidBankModal
                formName={SEND_FORM_NAME}
                actualRef={submitRef}
                popupRef={popupRef}
                modalRef={modalRef}
                typeOfTransfer={typeOfTransfer}
                changePaymentMethod={changePaymentMethodPlaid}
                onCloseModal={onClosePlaidModal}
            />
        );
    }
    if (modals.isFlinks) {
        return <FlinksModal popupRef={popupRef} submitRef={submitRef} formName={SEND_FORM_NAME} modalRef={modalRef} paymentSourceFromMethod={paymentMethod} />;
    }
    return null;
};
SdkModals.propTypes = {
    modalRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    popupRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    submitRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    changePaymentMethodPlaid: PropTypes.func.isRequired,
    paymentMethod: PropTypes.string.isRequired,
    modals: PropTypes.object.isRequired,
    typeOfTransfer: PropTypes.string,
    onClosePlaidModal: PropTypes.func,
};
export default connect(null, { toggleSpinner, setNewForm, addExtras, updatePageMessages })(SdkModals);
